import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-icon"]

import { type Component, type PropType, onMounted, ref } from "vue";
import { type IconKey, getComponentForIcon } from "./async-icons";

// eslint-disable-next-line no-undef

export default /*@__PURE__*/_defineComponent({
  __name: 'icon',
  props: {
    value: String as PropType<IconKey>,
    color: {
        type: String,
        default: "black",
    },
},
  setup(__props) {

const props = __props;

const componentData =
    props.value == null ? null : getComponentForIcon(props.value);
const compDefPromise = componentData != null ? componentData() : null;
const compDef = ref<Component | null>(null);

onMounted(async () => {
    if (compDefPromise != null) {
        // @ts-ignore
        compDef.value = await compDefPromise;
    }
});

return (_ctx: any,_cache: any) => {
  return (compDef.value != null)
    ? (_openBlock(), _createBlock(_resolveDynamicComponent(compDef.value), {
        key: 0,
        color: __props.color
      }, null, 8 /* PROPS */, ["color"]))
    : (_openBlock(), _createElementBlock("span", {
        key: 1,
        "data-icon": __props.value
      }, null, 8 /* PROPS */, _hoisted_1))
}
}

})